import * as React from 'react';
import { VisuallyHidden, VisuallyHiddenElement } from '../visually-hidden';

export interface LiveRegionProps {
    /** Announced whenever this text CHANGES. Render the region unconditionally and swap its children. */
    children?: React.ReactNode;
    politeness?: 'polite' | 'assertive';
    atomic?: boolean;
    as?: VisuallyHiddenElement;
    className?: string;
    testId?: string;
}

/** Visually hidden live region. Mount it with the surrounding UI, never conditionally. */
export const LiveRegion: React.FC<LiveRegionProps> = (props) => {
    const { children, politeness = 'polite', atomic = true, as = 'div', className, testId } = props;

    return (
        <VisuallyHidden as={as} className={className} testId={testId} aria-live={politeness} aria-atomic={atomic}>
            {children}
        </VisuallyHidden>
    );
};
